/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/ban-types */
export const EMPTY_FUNCTION: Function = () => {};
